
import * as angular from "angular";

export function capitalise() {

    return (input: string) => {
        return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : "";
    }
}
